<template>
  <div class="layout-padding">
    <div class="flex space-between" style="margin-bottom:12px" v-if="current_version">
      <div>
        <div>백오피스 최신 버전 : <span>{{current_version.version}}</span></div>
      </div>
      <button @click="openServiceUpdateModal" style="width:112px" class="button is-primary">서비스 업데이트</button>
    </div>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="1000"
                 @check="allCheck"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">

      <div slot="checkspot" slot-scope="props">
        <lp-check-bool :disabled="props.item.status !== 9"
          v-if="showcaseCheckArr[props.idx]!==undefined"
          :checkedVal.sync="showcaseCheckArr[props.idx].value"></lp-check-bool>
      </div>
      <div slot="status" slot-scope="props">{{ statusText(props.item.status) }}</div>

      <!-- 메뉴 관리 -->
      <!--<div slot="menu" slot-scope="props">
        <div class="unselect"
             style="text-decoration:underline"
             @click="$router.push(`service/menu?id=${props.item.id}`)">메뉴관리</div>
      </div>-->

      <div slot="log" slot-scope="props">
        <div class="unselect"
             style="text-decoration: underline"
             @click="$router.push(`service/log?id=${props.item.id}`)">로그관리</div>
      </div>

      <!--<div slot="office_updated_time" slot-scope="props">
        <div class="lp-valid-error"
             v-if="isBeforeTime(props.item)">{{ props.item.office_updated_time }}</div>
        <div v-else>{{ props.item.office_updated_time }}</div>
      </div>-->

      <span slot="version_office" slot-scope="props"
            :class="{'lp-valid-error': isBeforeVersion(props.item) }">{{ props.item.version_office }}</span>
    </admin-table>

    <modal name="serviceUpdateModal" :adaptive="true" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <div>선택된 메뉴 {{ selectedCount }}개를 업데이트 처리하시겠습니까?</div>
        <div class="btn-group-justify-end">
          <button class="button is-light" @click="$modal.hide('serviceUpdateModal')">취소</button>
          <button class="button is-primary" @click="serviceUpdate">확인</button>
        </div>
      </div>
    </modal>

  </div>
</template>

<script>
  import LpSortDropDown from '../../../module/common/LpSortDropDown'
  import LpInputText from '../../../module/common/LpInputText'
  import LpRadio from '../../../module/common/LpRadio'
  import LpCheckBool from '../../../module/common/LpCheckBool'
  import { SweetModal } from 'sweet-modal-vue'
  import LpModal from '../../../module/common/LpModal.vue'
  import ListMixin from '@/mixins/ListMixin'

  export default {
    name: 'service-version-list',
    mixins: [
      ListMixin
    ],
    props: ['page'],
    components: {
      SweetModal, LpSortDropDown,
      LpInputText, LpRadio, LpModal,
      LpCheckBool
    },
    data () {
      return {
        selectedCount: 0,
        current_version: undefined
      }
    },
    created() {
      this.getCurrentVersion();
      this.initializing('launchpack_service_version', 'launchpack/service/version');
    },
    methods: {
      /*// 서비스 백오피스 업데이트 날짜가 현재 배포된 버전의 날짜보다 전일 경우
      isBeforeTime(item) {
        return this.moment(item.office_updated_time).isBefore(this.current_version.updated_time);
      },*/
      statusText(value) {
        return {
          0: '이용 예정',
          1: '결제 완료',
          2: 'database_finish',
          3: 'backend_finish',
          4: 'front_finish',
          5: '개설 진행중',
          6: '디자인 수정중',
          9: '이용중',
          10: '관리자 정지',
          99: '전체 정지',
          100: '이용중단',
          101: '삭제됨'
        }[value];
      },
      getDataFromServer() {
        this.getData();
      },
      isBeforeVersion(item) {
        return item.version_office < this.current_version.version;
      },
      getCurrentVersion() {
        this.$axios.get('admin/launchpack/service/current_version').then(res => {
          this.current_version = res.data;
        })
      },
      allCheck(n) {
        this.showcaseCheckArr.forEach(item=>{
          item.value = n;
        });
      },
      openServiceUpdateModal () {
        this.selectedCount = 0;
        let checked = this.getCheckedArr();
        if(checked.length===0) {
          this.toast('업데이트할 서비스를 선택하세요');
          return;
        }
        this.selectedCount = checked.length;
        this.$modal.show('serviceUpdateModal');
      },
      serviceUpdate () {
        this.$axios.post('admin/launchpack/service/office/update/multiple', {
          version: this.current_version.version,
          checked: this.getCheckedArr()
        }).then(res=> {
          if(res.status===200) {
            this.tableItems.forEach(item=>{
              if(find(this.showcaseCheckArr, 'id', item.id).value) {
                item.version_office = this.current_version.version;
              }
            });
            this.$modal.hide('serviceUpdateModal');
            this.toast('선택된 서비스 업데이트가 완료되었습니다')
          }
        })
      },
      setRemain(item, e) {
        item.remain = e.target.value;
        item.saveEnable = true;
      },
      saveItem(item) {
        this.$axios.patch(this.getUrl('launchpack/service/'+item.id), {
          status: item.status,
          remain: item.remain
        }).then(res => {
          if(res.status === 200) {
            this.toast('저장되었습니다.');
            item.saveEnable = false;
          }

        });
      },
      sendAccountMail(item) {
        this.$axios.get(this.getUrl('launchpack/service/resend_mail_account/'+item.id))
          .then(res => {
            if(res.status === 200) {
              this.toast('저장되었습니다.');
            }
          });
      },
      clickModifyDelete(item, type) {
        if(type === 'update') {
          this.$router.push(this.getPath(`launchpack/service/update?id=${item.id}`));
        }
        if(type === 'delete') {
          let value = {
            url: `launchpack/service/${item.id}`,
            title: '서비스를 삭제하시겠습니까?'
          }
          this.$store.commit('openModal', {type: 'modal-delete', value: value, width: 500});
        }
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  //@import '~assets/css/reset'
  @import '~assets/css/lp_main'

  .modalpage
    margin-top 50px

</style>
